module.exports = __webpack_public_path__ + "img/creerCommande.e343268e.png";